const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Giropay24 = function Giropay24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 6.0868C0 4.30326 1.45829 2.85718 3.25625 2.85718H38.7438C40.5425 2.85718 42 4.30326 42 6.0868V17.6283C42 19.4108 40.5425 20.8572 38.7438 20.8572H3.25625C1.45829 20.8572 0 19.4108 0 17.6283V6.0868Z",
      fill: "#000268",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.33643 6.1973V17.5189C1.33643 18.6332 2.24794 19.537 3.37232 19.537H21.9646V4.1792H3.37232C2.24794 4.1792 1.33643 5.08296 1.33643 6.1973ZM26.7685 11.8015C26.7685 12.5224 26.4107 13.0178 25.8185 13.0178C25.2953 13.0178 24.8591 12.5224 24.8591 11.8622C24.8591 11.1847 25.2427 10.6809 25.8185 10.6809C26.4291 10.6809 26.7685 11.2022 26.7685 11.8015ZM23.291 15.9357H24.8591V13.4775H24.8766C25.1737 14.0161 25.7667 14.2157 26.3156 14.2157C27.6661 14.2157 28.3894 13.1043 28.3894 11.7666C28.3894 10.6726 27.7012 9.48191 26.4458 9.48191C25.7317 9.48191 25.0693 9.76885 24.7548 10.4031H24.7373V9.58695H23.291V15.9357ZM30.5312 12.6785C30.5312 12.2445 30.949 12.0801 31.4814 12.0801C31.7165 12.0801 31.9434 12.0965 32.1437 12.1059C32.1437 12.6355 31.769 13.1741 31.176 13.1741C30.8099 13.1741 30.5312 12.992 30.5312 12.6785ZM33.6943 14.1118C33.625 13.756 33.6075 13.3993 33.6075 13.0436V11.3585C33.6075 9.97759 32.6058 9.48191 31.4464 9.48191C30.7757 9.48191 30.1918 9.57755 29.6338 9.80376L29.6604 10.8639C30.0947 10.6202 30.6012 10.5246 31.1067 10.5246C31.6723 10.5246 32.1343 10.6901 32.1437 11.3069C31.9434 11.272 31.6639 11.2454 31.4113 11.2454C30.5754 11.2454 29.0674 11.4109 29.0674 12.7916C29.0674 13.7735 29.8688 14.2157 30.7665 14.2157C31.4113 14.2157 31.8475 13.9648 32.2046 13.3993H32.2222C32.2222 13.6346 32.2478 13.8681 32.2572 14.1118H33.6943ZM34.4 15.9357C34.7227 16.0056 35.0449 16.0407 35.3759 16.0407C36.8141 16.0407 37.1534 14.9373 37.598 13.7993L39.2631 9.58695H37.6939L36.7615 12.5398H36.744L35.7678 9.58695H34.0779L35.9164 14.2157C35.8029 14.6155 35.5069 14.8417 35.123 14.8417C34.9044 14.8417 34.7136 14.8151 34.5041 14.7461L34.4 15.9357Z",
      fill: "white",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.16729 11.8108C5.16729 11.1939 5.4727 10.6811 6.05659 10.6811C6.76234 10.6811 7.05834 11.2455 7.05834 11.7493C7.05834 12.4443 6.61381 12.9131 6.05659 12.9131C5.58619 12.9131 5.16729 12.5141 5.16729 11.8108ZM8.57493 9.58707H7.1543V10.4033H7.13782C6.80573 9.84714 6.26499 9.48204 5.59455 9.48204C4.18307 9.48204 3.54663 10.4906 3.54663 11.8366C3.54663 13.1742 4.32244 14.1119 5.56762 14.1119C6.19596 14.1119 6.71893 13.8682 7.09337 13.3387H7.11089V13.5823C7.11089 14.4679 6.62297 14.8934 5.71719 14.8934C5.06322 14.8934 4.66185 14.7545 4.18307 14.5203L4.10463 15.7539C4.46993 15.8845 5.08886 16.0409 5.83904 16.0409C7.66915 16.0409 8.57493 15.4412 8.57493 13.5823V9.58707ZM11.2261 7.70239H9.6572V8.84878H11.2261V7.70239ZM9.65799 14.1119H11.2261V9.58707H9.65799V14.1119ZM15.5939 9.53443C15.437 9.50888 15.2451 9.48204 15.0626 9.48204C14.3827 9.48204 13.9907 9.84714 13.7204 10.4207H13.7028V9.58707H12.2739V14.1119H13.8422V12.2017C13.8422 11.3154 14.2525 10.7858 14.9841 10.7858C15.1677 10.7858 15.341 10.7858 15.5155 10.8372L15.5939 9.53443ZM18.2948 13.1219C17.5715 13.1219 17.2755 12.5225 17.2755 11.854C17.2755 11.1765 17.5715 10.5771 18.2948 10.5771C19.0188 10.5771 19.3151 11.1765 19.3151 11.854C19.3151 12.5225 19.0188 13.1219 18.2948 13.1219ZM18.2948 14.2159C19.7938 14.2159 20.9357 13.3481 20.9357 11.854C20.9357 10.3509 19.7938 9.48204 18.2948 9.48204C16.7959 9.48204 15.6548 10.3509 15.6548 11.854C15.6548 13.3481 16.7959 14.2159 18.2948 14.2159Z",
      fill: "#FF0007",
    })
  );
};
Giropay24.defaultProps = {
  width: "42",
  height: "24",
  viewBox: "0 0 42 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Giropay24,
};
export function Giropay(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Giropay' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
